export default "__VITE_ASSET__ab48789d__"